import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const FollowedAthletesSectionSection = styled.div.attrs({ className: "mt-8" })``;

export const FollowedAthletesSectionInfoRow = styled.div.attrs({
  className: "flex items-center gap-3",
})``;

export const FollowedAthletesSectionThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const FollowedAthletesSectionLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const FollowedAthletesSectionMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;
